import React from 'react';
import { Alert, Checkbox, Divider, Input, Spin } from 'antd';
import { connect } from 'react-redux';
import { FcTodoList } from 'react-icons/fc';

import { IReduxState } from 'src/store';
import { fetchTask } from 'src/store/tasks/actions';
import {
  TaskMaintenanceType,
  TaskStage,
} from 'src/interfaces/task';
import { checklistProgress } from 'src/utils';

import { IProps } from './checklist.type';
import {
  Wrapper,
  Title,
  Progress,
  ItemRow,
  ItemTitle,
  ItemDescription,
} from './checklist.style';
import useChecklist from './checklist.use';

const ChecklistComponent: React.FC<IProps> = (props) => {
  const { task } = props;
  const { savingId, handleToggle, handleNotesBlur } = useChecklist(props);

  if (
    !task ||
    task.maintenanceType !== TaskMaintenanceType.PREVENTIVE ||
    !(task.checklistItems && task.checklistItems.length > 0)
  ) {
    return null;
  }

  const readonly = task.stage === TaskStage.DONE;
  const { completed, total } = checklistProgress(task.checklistItems);
  const items = [...task.checklistItems].sort(
    (a, b) => a.position - b.position || a.id - b.id
  );

  return (
    <Wrapper>
      <Title>
        <FcTodoList size={20} className="me-2" />
        <h4 className="m-0">Checklist preventivo</h4>
      </Title>
      <Divider className="mt-2 mb-2" />

      <Progress>
        Progresso: {completed}/{total} concluídos
      </Progress>

      <Alert
        type="info"
        className="mb-0"
        description={
          <Spin spinning={savingId !== null}>
            {items.map((item) => (
              <ItemRow key={item.id}>
                <Checkbox
                  checked={item.completed}
                  disabled={readonly || savingId === item.id}
                  onChange={(event) =>
                    handleToggle(item, event.target.checked)
                  }
                >
                  <ItemTitle>{item.title}</ItemTitle>
                  {item.required ? <small> (obrigatório)</small> : null}
                </Checkbox>
                {item.description ? (
                  <ItemDescription>{item.description}</ItemDescription>
                ) : null}
                <Input.TextArea
                  key={`${item.id}-${item.notes || ''}-${item.completed}`}
                  rows={2}
                  className="mt-1"
                  placeholder="Observações (opcional)"
                  defaultValue={item.notes || ''}
                  disabled={readonly || savingId === item.id}
                  onBlur={(event) =>
                    handleNotesBlur(item, event.target.value)
                  }
                />
              </ItemRow>
            ))}
          </Spin>
        }
      />
    </Wrapper>
  );
};

const mapStateToProps = (state: IReduxState) => ({
  task: state.tasks.current,
});

export default connect(mapStateToProps, { fetchTask })(ChecklistComponent);
